import { render, staticRenderFns } from "./tipoPatologia.vue?vue&type=template&id=84d4d670"
import script from "./tipoPatologia.vue?vue&type=script&lang=js"
export * from "./tipoPatologia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports